import React from "react";
import styled from "styled-components";
import resume from "../img/adnan.jpeg";

function ImageSection() {
  return (
    <ImageSectionStyled>
      <div className="left-content">
        <img src={resume} alt="" />
      </div>
      <div className="right-content">
        <h4>
          I am <span> Abm Adnan Azmee </span>
        </h4>
        <p className="paragraph">
          A PhD Candidate at Kennesaw State University, Computer Science department.
          My primary research interest lies in machine learning, natural language processing, 
          and its diverse applications. I have a background as a full-stack developer, with 
          industry experience in various software technologies such as Angular, NodeJS, 
          ExpressJS, NestJS and more.
        </p>

        <p className="paragraph">
          As a tech enthusiast, I always try to keep myself up to date with the
          latest trends in the world of technology. I love traveling. Besides, I
          enjoy my free time reading books, watching documentaries or learning
          something new.
        </p>
        {/* <div className="about-info">
          <div className="info-title">
            <p>Full Name</p>
            <p>Age</p>
            <p>Nationality </p>
            <p>Languages </p>
            <p>Location</p>
            <p>Service</p>
          </div>
          <div className="info">
            <p>: Lorem Ipsum</p>
            <p>: 36</p>
            <p>: Spainsh </p>
            <p>: Spanish, French, English </p>
            <p>: London, United Kingdom</p>
            <p>: Freelance</p>
          </div>
        </div> */}
        {/* <PrimaryButton title={"Download Cv"} /> */}
      </div>
    </ImageSectionStyled>
  );
}

const ImageSectionStyled = styled.div`
  margin-top: 5rem;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .left-content {
      margin-bottom: 2rem;
    }
  }
  .left-content {
    width: 100%;
    img {
      width: 95%;
      object-fit: cover;
    }
  }
  .right-content {
    width: 100%;
    h4 {
      font-size: 2rem;
      color: var(--white-color);
      span {
        font-size: 2rem;
      }
    }
    .paragraph {
      padding: 1rem 0;
    }
    .about-info {
      display: flex;
      padding-bottom: 1.4rem;
      .info-title {
        padding-right: 3rem;
        p {
          font-weight: 600;
        }
      }
      .info-title,
      .info {
        p {
          padding: 0.3rem 0;
        }
      }
    }
  }
`;
export default ImageSection;
